import {Component, Input, OnInit} from '@angular/core';
import {
  BokkzAlgDataService,
  BokkzBtwDataService,
  BtwOverzicht,
  KolommenbalansService,
  ValueAddedTaxEntity
} from "@snelstart-ventures/fiscaal/domain-logic";
import { SelectFormControlItem, SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import {FormBuilder, FormGroup} from "@angular/forms";
import { SharedUiButtonModule } from '@snelstart/ui-button';
import { SharedUiDetailsModule } from '@snelstart/ui-details';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-administratie-koppelen',
  templateUrl: './administratie-koppelen.component.html',
  styleUrls: ['./administratie-koppelen.component.scss'],
  imports: [
    SharedUiButtonModule,
    SharedUiFormControlsModule,
    SharedUiDetailsModule
  ]
})
export class AdministratieKoppelenComponent implements OnInit {

  @Input() public id!: string;
  public vatEntity = {} as ValueAddedTaxEntity;
  public options: SelectFormControlItem<string>[] = [];
  public sstAdminIdFg= {} as FormGroup;

  constructor(
    public dataService: BokkzBtwDataService,
    public bokkzDataService: BokkzAlgDataService,
    private kolommenbalansService: KolommenbalansService,
    private fb: FormBuilder) {
    this.sstAdminIdFg = this.fb.group({
      administratieId: null as unknown as string,
    })
  }

  ngOnInit(): void {
    this.dataService.valueAddedTaxEntity.subscribe((value) => {
      this.vatEntity = value;
    });
    this.bokkzDataService.options.subscribe((value) => {
      this.options = value;
      this.sstAdminIdFg.patchValue(value, {emitEvent: false})
    });
  }

  getAdministration() {
    // this.kolommenbalansService.getUpdatedAangifteMetAdministratie(this.sstAdminIdFg.value.administratieId, this.vpbAangifte)
    //   .then((aangifte) => {
    //     if (aangifte.identificatie) {
    //       this.dataService.updateAangifte(aangifte as VpbAangifte)
    //     }
    //   })
  }

  saveForm(): void {
    this.vatEntity.overzicht = {
      ...this.vatEntity.overzicht,
      sstAdminId: this.sstAdminIdFg.getRawValue().administratieId
    } as BtwOverzicht;
    this.dataService.updateValueAddedTaxEntity(this.vatEntity);
  }

}
